import { AutoSkipContentUnlockedReason } from 'components/newListeningExperience/settings/Settings';
import { AuthStoreState } from 'modules/auth/store/authStore';
import { getIsAnonymous } from 'modules/auth/store/authStore/selectors/getIsAnonymous';
import { ListeningModeStoreState, ListeningOwnership } from 'modules/listening/stores/listeningMode/listeningModeStore';

import { SubscriptionStoreState } from '../subscriptionStore';

type SkipContentUnlockedResult = {
  skipContentUnlocked: boolean;
  skipContentUnlockedReason?: AutoSkipContentUnlockedReason;
};

export const getIsSkipContentUnlocked = ({
  subscriptionStoreState,
  listeningModeStoreState,
  authStoreState
}: {
  subscriptionStoreState: SubscriptionStoreState;
  listeningModeStoreState: ListeningModeStoreState;
  authStoreState: AuthStoreState;
}): SkipContentUnlockedResult => {
  if (subscriptionStoreState.isPremium) {
    return {
      skipContentUnlocked: true,
      skipContentUnlockedReason: AutoSkipContentUnlockedReason.Premium
    };
  }

  const isAnonymous = getIsAnonymous(authStoreState);
  if (isAnonymous && listeningModeStoreState.ownership === ListeningOwnership.SHARED) {
    return {
      skipContentUnlocked: true,
      skipContentUnlockedReason: AutoSkipContentUnlockedReason.Shared
    };
  }

  return {
    skipContentUnlocked: false
  };
};
